import { useContext, useEffect } from "react";
import { WidgetContext } from "../../../context/widgetContext";
import HtmlParsedText from "../../common/HtmlParsedText";

const SidebarSection = () => {
	const { forum_overview_members_online, tag_cloud, fetchWidgetHtml } = useContext(WidgetContext);

	useEffect(() => {
		fetchWidgetHtml("forum_overview_members_online");
		fetchWidgetHtml("tag_cloud");
	}, [fetchWidgetHtml]);

	return (
		<>
			<div className="mb-4">
				{forum_overview_members_online && <HtmlParsedText text={forum_overview_members_online} />}
			</div>

			<div className="mb-4">
				{tag_cloud && <HtmlParsedText text={tag_cloud} />}
			</div>
		</>
	);
};

export default SidebarSection;
